module.exports = __webpack_public_path__ + "img/visa.19a95992.png";